<div [formGroup]="formGroup">
  <div class="form-control">
    <label [for]="prefix + 'address'">{{
      customAddressLabel | translate
    }}</label>
    @if (selectSavedAddressBtn) {
      <div class="address-btn" (click)="selectAddressModal()">
        {{ 'DELIVERY.CHOICE_ADDRESS' | translate }}
      </div>
    }
    <div class="position-relative">
      <ng-select
        #ngSelect
        [items]="autocompleteAddress$ | async"
        [id]="prefix + 'address'"
        [labelForId]="prefix + 'address'"
        [markFirst]="false"
        [searchFn]="customSearchFn"
        (search)="search($event)"
        [placeholder]="'ADDRESS_PLACEHOLDER' | translate"
        [notFoundText]="'ENTER_TEXT_FOR_SEARCH' | translate"
        [closeOnSelect]="true"
        [clearOnBackspace]="false"
        [loading]="loadingAutocomplete"
        [loadingText]="'LOADING' | translate"
        (change)="setAddress($event)"
        formControlName="address"
      >
        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
          <span
            [innerHTML]="item.short_address || item.address | highlight: search"
          ></span>
        </ng-template>
      </ng-select>

      <app-control-errors control="address"></app-control-errors>
    </div>

    @if (findIndexLink && addressBookPath) {
      <small class="text-right float-right ml-2">
        <a target="_blank" [href]="addressBookPath">
          {{ 'OPEN_ADRESSBOOK' | translate }}
        </a>
      </small>
    }
  </div>
  @if (showFullAddress) {
    <div class="house-control">
      <div class="house-control__item form-control">
        <label [for]="prefix + 'building'">{{
          'HOUSE_TITLE' | translate
        }}</label>
        @if ((autocompleteBuildings$ | async).length) {
          <ng-select
            #ngSelect
            [items]="autocompleteBuildings$.value"
            formControlName="building"
            [id]="prefix + 'building'"
            [labelForId]="prefix + 'building'"
            [markFirst]="false"
            [searchFn]="filterBuildings"
            (search)="
              setValueOnSearch($event, 'building', autocompleteBuildings$)
            "
            [placeholder]="'HOUSE_PLACEHOLDER' | translate"
            appendTo="body"
            [notFoundText]="'ENTER_TEXT_FOR_SEARCH' | translate"
            [closeOnSelect]="true"
            [clearOnBackspace]="false"
            [loadingText]="'LOADING' | translate"
            class="house-control__item_control"
          >
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <span [innerHTML]="item | highlight: search"></span>
            </ng-template>
          </ng-select>
        } @else {
          <input
            formControlName="building"
            [id]="prefix + 'building'"
            type="text"
            class="house-control__item_control"
            [placeholder]="'HOUSE_PLACEHOLDER' | translate"
          />
        }
        <app-control-errors control="building"></app-control-errors>
      </div>
      <div class="house-control__item form-control">
        <label [for]="prefix + 'housing'">{{
          'BUILDING_TITLE' | translate
        }}</label>
        @if ((autocompleteHousing$ | async).length) {
          <ng-select
            #ngSelect
            [items]="autocompleteHousing$.value"
            formControlName="housing"
            [id]="prefix + 'housing'"
            [labelForId]="prefix + 'housing'"
            [markFirst]="false"
            [searchFn]="filterBuildings"
            appendTo="body"
            (search)="setValueOnSearch($event, 'housing', autocompleteHousing$)"
            [placeholder]="'BUILD_PLACEHOLDER' | translate"
            [notFoundText]="'ENTER_TEXT_FOR_SEARCH' | translate"
            [closeOnSelect]="true"
            [clearOnBackspace]="false"
            [loadingText]="'LOADING' | translate"
            class="house-control__item_control"
          >
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <span [innerHTML]="item | highlight: search"></span>
            </ng-template>
          </ng-select>
        } @else {
          <input
            type="text"
            formControlName="housing"
            [id]="prefix + 'housing'"
            class="house-control__item_control"
            [placeholder]="'BUILD_PLACEHOLDER' | translate"
          />
        }
        <app-control-errors control="housing"></app-control-errors>
      </div>
      <div class="house-control__item form-control">
        <label [for]="prefix + 'apartment'">{{
          'DELIVERY.APPART' | translate
        }}</label>
        <input
          type="text"
          formControlName="apartment"
          [id]="prefix + 'apartment'"
          class="house-control__item_control"
          [placeholder]="'APPART_PLACEHOLDER' | translate"
        />
        <app-control-errors control="apartment"></app-control-errors>
      </div>
    </div>
  }
</div>
